/**
 * BattleTeamData 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * BattleTeamData
 */
export interface BattleTeamData {
  /** 总分 */
  score?: number
  /** 玩家数 */
  player_count?: number
  /** 导弹能量 */
  energy?: number
  /** 消息计数 */
  message_count?: number
}

/**
 * BattleTeamData Schema
 */
export const BattleTeamDataSchema: SchemaDefinition = {
  properties: {
    score: {
      description: '总分',
      format: 'float64',
      type: 'number',
      label: '总分',
    },
    player_count: {
      description: '玩家数',
      format: 'int',
      type: 'integer',
      label: '玩家数',
    },
    energy: {
      description: '导弹能量',
      format: 'int',
      type: 'integer',
      label: '导弹能量',
    },
    message_count: {
      description: '消息计数',
      format: 'int',
      type: 'integer',
      label: '消息计数',
    },
  },
  type: 'object',
}
